module.exports = __webpack_public_path__ + "img/default.cef72080.svg";